var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"stats-card"},[(_vm.dataPrepared)?_c('div',[_c('vue-apex-charts',{key:"real-one",attrs:{"height":"200","options":_vm.lineChartSimple.chartOptions,"series":_vm.lineChartSimple.series}})],1):_c('div',[_c('vue-apex-charts',{key:"placehodler",attrs:{"height":"200","options":_vm.lineChartSimple.chartOptions,"series":[]}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }